"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactRepository = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const contact_entity_1 = require("../../../../service-lib/src/lib/entities/contact.entity");
const contact_address_entity_1 = require("../../../../service-lib/src/lib/entities/contact-address.entity");
const contact_details_entity_1 = require("../../../../service-lib/src/lib/entities/contact-details.entity");
const company_address_entity_1 = require("../../../../service-lib/src/lib/entities/company.address.entity");
const contact_document_map_entity_1 = require("../../../../service-lib/src/lib/entities/contact-document-map.entity");
const company_contact_entity_1 = require("../../../../service-lib/src/lib/entities/company-contact.entity");
const contact_communication_details_entity_1 = require("../../../../service-lib/src/lib/entities/contact-communication-details.entity");
const professional_experience_entity_1 = require("../../../../service-lib/src/lib/entities/professional-experience.entity");
const qualification_experience_entity_1 = require("../../../../service-lib/src/lib/entities/qualification-experience.entity");
const look_up_entity_1 = require("../../../../service-lib/src/lib/entities/look-up.entity");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const enum_1 = require("../../../../../../libs/service-lib/src/lib/enum");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const insurer_entity_1 = require("../../../../service-lib/src/lib/entities/insurer.entity");
const tpa_entity_1 = require("../../../../service-lib/src/lib/entities/tpa.entity");
const child_details_entity_1 = require("../../../../service-lib/src/lib/entities/child-details.entity");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
const constants_2 = require("../../../../service-lib/src/lib/constants");
/**
 * Repository for managing contact-related database operations.
 */
let ContactRepository = class ContactRepository {
    constructor(contactRepository, contactCommunicationDetailsRepository, contactDetailsRepository, childDetailsRepository, professionalExperienceRepository, qualificationExperienceRepository, contactAddressRepository, companyAddressRepository, contactDocumentMapRepository, companyContactMapRepository, insurerRepository, tpaRepository, lookUpRepository, dataSource, entityService, scopeService) {
        this.contactRepository = contactRepository;
        this.contactCommunicationDetailsRepository = contactCommunicationDetailsRepository;
        this.contactDetailsRepository = contactDetailsRepository;
        this.childDetailsRepository = childDetailsRepository;
        this.professionalExperienceRepository = professionalExperienceRepository;
        this.qualificationExperienceRepository = qualificationExperienceRepository;
        this.contactAddressRepository = contactAddressRepository;
        this.companyAddressRepository = companyAddressRepository;
        this.contactDocumentMapRepository = contactDocumentMapRepository;
        this.companyContactMapRepository = companyContactMapRepository;
        this.insurerRepository = insurerRepository;
        this.tpaRepository = tpaRepository;
        this.lookUpRepository = lookUpRepository;
        this.dataSource = dataSource;
        this.entityService = entityService;
        this.scopeService = scopeService;
    }
    /** Creates a new contact in the database.*/
    async createContact(createContact) {
        try {
            const contact = this.contactRepository.create(createContact);
            const savedContact = await this.dataSource.manager.save(constants_1.DEFAULT_CONTACT_ENTITY_NAME, contact);
            return savedContact;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.contactQueryCreationFailed));
        }
    }
    /** Creates an contact details */
    async createContactDetails(contactDetailsData) {
        try {
            const contactDetails = this.contactDetailsRepository.create(contactDetailsData);
            const savedContactDetails = await this.contactDetailsRepository.save(contactDetails);
            return savedContactDetails;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.contactQueryCreationFailed));
        }
    }
    /** Creates an child details */
    async createChildDetails(childDetailsData) {
        try {
            const childDetails = this.childDetailsRepository.create(childDetailsData);
            const savedChildDetails = await this.childDetailsRepository.save(childDetails);
            return savedChildDetails;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.childQueryCreationFailed));
        }
    }
    /** Updates an existing child detail. */
    async updateChildDetails(id, childDetailsData) {
        try {
            const existingChildDetails = await this.childDetailsRepository.findOne({
                where: { id },
            });
            if (!existingChildDetails) {
                throw new common_1.NotFoundException(`ChildDetails with ID ${id} not found`);
            }
            const mergedChildDetails = this.childDetailsRepository.merge(existingChildDetails, childDetailsData);
            return await this.childDetailsRepository.save(mergedChildDetails);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.childQueryUpdationFailed));
        }
    }
    /** Delete the child detail */
    async deleteChildDetails(contactDetailsId) {
        try {
            const childDetails = await this.childDetailsRepository.find({
                where: { contactDetails: { id: contactDetailsId } },
            });
            if (childDetails.length) {
                // Perform a soft delete by updating the `deleted_at` column
                await this.childDetailsRepository.update({ contactDetails: { id: contactDetailsId } }, { deletedAt: new Date() });
            }
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.childQueryUpdationFailed));
        }
    }
    /** Creates an professional experience associated with contact */
    async createProfessionalExperience(professionalExperienceDataObject) {
        try {
            const professionalExperienceData = this.professionalExperienceRepository.create(professionalExperienceDataObject);
            const savedProfessionalDetails = await this.professionalExperienceRepository.save(professionalExperienceData);
            return savedProfessionalDetails;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.contactQueryCreationFailed));
        }
    }
    /** Creates an qualification experience associated with contact */
    async createQualificationExperience(qualificationExperienceData) {
        try {
            const qualificationExperience = this.qualificationExperienceRepository.create(qualificationExperienceData);
            const savedQualificationDetails = await this.qualificationExperienceRepository.save(qualificationExperience);
            return savedQualificationDetails;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.contactQueryCreationFailed));
        }
    }
    /** Fetches all contact details from the database.*/
    async fetchAllContacts() {
        try {
            return await this.contactRepository.find();
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.contactQueryFetchFailed));
        }
    }
    /** Fetches paginated contact details from the database. */
    async fetchPaginatedContactList(page, limit, userId, contactRecordTypeLid, searchArray, sort, searchBy, contactSearchObject) {
        try {
            const status = await this.lookUpRepository.findOne({
                where: { lookUpKey: constants_1.DEFAULT_CONTACT_STATUS_ACTIVE_KEY },
            });
            const whereCondition = {
                contactRecordTypeLid: contactRecordTypeLid,
                statusLid: status?.id ?? undefined,
            };
            const contactRecordTypeLookup = await this.lookUpRepository.findOne({
                where: { id: contactRecordTypeLid },
            });
            const recordType = constants_2.CONTACT_RECORD_TYPE_MAP[contactRecordTypeLookup.lookUpKey];
            const relations = await this.getContactRelations(recordType);
            // const { data, count } = await this.entityService.fetchEntityList(
            //   DEFAULT_CONTACT_ENTITY_NAME,
            //   page,
            //   limit,
            //   sort && sort?.length > 0 ? sort : [{ field: "id", order: "DESC" }],
            //   relations,
            //   whereCondition,
            //   undefined,
            //   searchArray && searchArray?.length === 0 ? [] : searchArray,
            //   undefined,
            //   searchBy,
            //   contactSearchObject
            // );
            const { data, count } = await this.scopeService.validateScope({
                entity: constants_1.DEFAULT_CONTACT_ENTITY_NAME,
                page: page,
                limit: limit,
                sort: sort && sort?.length > 0 ? sort : [{ field: "id", order: "DESC" }],
                relations: relations,
                where: whereCondition,
                select: undefined,
                searchArray: searchArray && searchArray?.length === 0 ? [] : searchArray,
                userFilter: undefined,
                searchString: searchBy,
                searchOn: contactSearchObject,
            }, userId, "contact");
            let contactData = [];
            if (data?.length) {
                contactData = data.map((contact) => ({
                    id: contact.id,
                    contactName: contact?.middleName
                        ? `${contact?.firstName} ${contact?.middleName} ${contact?.lastName}`
                        : `${contact?.firstName} ${contact?.lastName}`,
                    displayName: contact?.displayName,
                    tag: contact?.tag ? contact?.tag?.lookUpValue : null,
                    companyId: recordType === constants_2.CONTACT_RECORD_TYPE_MAP.COMPANY_CONTACT_RECORD_TYPE
                        ? contact?.companyContactMaps[0]?.company?.id
                        : recordType ===
                            constants_2.CONTACT_RECORD_TYPE_MAP.INSURER_CONTACT_RECORD_TYPE
                            ? contact?.insurerContacts[0]?.insurer?.id
                            : recordType === constants_2.CONTACT_RECORD_TYPE_MAP.TPA_CONTACT_RECORD_TYPE
                                ? contact?.tpaContacts[0]?.tpa?.id
                                : contact?.brokerContacts[0]?.broker?.id,
                    companyName: recordType === constants_2.CONTACT_RECORD_TYPE_MAP.COMPANY_CONTACT_RECORD_TYPE
                        ? contact?.companyContactMaps[0]?.company?.companyName
                        : recordType ===
                            constants_2.CONTACT_RECORD_TYPE_MAP.INSURER_CONTACT_RECORD_TYPE
                            ? contact?.insurerContacts[0]?.insurer?.insurerName
                            : recordType === constants_2.CONTACT_RECORD_TYPE_MAP.TPA_CONTACT_RECORD_TYPE
                                ? contact?.tpaContacts[0]?.tpa?.tpaName
                                : contact?.brokerContacts[0]?.broker?.brokerName,
                    numberOfAddress: Array.isArray(contact?.contactAddresses)
                        ? contact.contactAddresses.length
                        : 0,
                    communicationDetails: contact?.communicationDetails?.map((communication) => {
                        return {
                            id: communication?.id,
                            communicationType: communication?.communicationType,
                            communicationDetails: communication?.communicationDetails,
                            isPrimary: communication?.isPrimary,
                        };
                    }),
                    status: contact.status
                        ? {
                            id: contact.status.id,
                            lookUpValue: contact.status.lookUpValue,
                        }
                        : null,
                    owner: contact?.owner
                        ? {
                            userId: contact?.owner?.userId,
                            firstName: contact?.owner?.firstName,
                            lastName: contact?.owner?.lastName,
                        }
                        : null,
                    department: contact?.department ? contact?.department : null,
                    designation: contact?.designation ? contact?.designation : null,
                }));
            }
            return {
                data: contactData,
                count: count,
            };
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.contactQueryFetchFailed));
        }
    }
    async getContactRelations(recordType) {
        let relations = [];
        if (recordType === constants_2.CONTACT_RECORD_TYPE_MAP.COMPANY_CONTACT_RECORD_TYPE) {
            relations = [
                "companyContactMaps",
                "companyContactMaps.company",
                "companyContactMaps.company.companyAddresses",
                "companyContactMaps.company.companyAddresses.address",
                "companyContactMaps.company.companyAddresses.address.cityId",
                "companyContactMaps.contact",
                "communicationDetails",
                "owner",
                "tag",
                "status",
            ];
        }
        else if (recordType === constants_2.CONTACT_RECORD_TYPE_MAP.INSURER_CONTACT_RECORD_TYPE) {
            relations = [
                "insurerContacts",
                "insurerContacts.insurer",
                "insurerContacts.insurer.insurerAddresses",
                "insurerContacts.insurer.insurerAddresses.address",
                "insurerContacts.insurer.insurerAddresses.address.cityId",
                "communicationDetails",
                "owner",
                "tag",
                "status",
            ];
        }
        else if (recordType === constants_2.CONTACT_RECORD_TYPE_MAP.TPA_CONTACT_RECORD_TYPE) {
            relations = [
                "tpaContacts",
                "tpaContacts.tpa",
                "tpaContacts.tpa.tpaAddresses",
                "tpaContacts.tpa.tpaAddresses.address",
                "tpaContacts.tpa.tpaAddresses.address.cityId",
                "communicationDetails",
                "owner",
                "tag",
                "status",
            ];
        }
        else if (recordType === constants_2.CONTACT_RECORD_TYPE_MAP.BROKER_CONTACT_RECORD_TYPE) {
            relations = [
                "brokerContacts",
                "brokerContacts.broker",
                "brokerContacts.broker.brokerAddresses",
                "brokerContacts.broker.brokerAddresses.address",
                "brokerContacts.broker.brokerAddresses.address.cityId",
                "communicationDetails",
                "owner",
                "tag",
                "status",
            ];
        }
        return relations;
    }
    /** Retrieves existing contact details based on the provided contact ID. */
    async getExistingContactDetails(contactId) {
        try {
            const existingContactDetails = await this.contactRepository.findOne({
                where: { id: contactId },
                relations: ["contactRecordType"],
            });
            if (!existingContactDetails) {
                throw new common_1.NotFoundException(`Contact with ID ${contactId} not found`);
            }
            return existingContactDetails;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.contactDataNotFound));
        }
    }
    /** Retrieves the details of a specific contact by ID. */
    async getContactData(id) {
        try {
            const existingContactDetails = await this.getExistingContactDetails(id);
            const contactRecord = constants_2.CONTACT_RECORD_TYPE_MAP[existingContactDetails?.contactRecordType
                ?.lookUpKey];
            const contactRelations = [
                "contactAddresses.address.addressType",
                "contactDetails.genderType",
                "contactDetails.spouseWorkingStatusType",
                "contactDetails.maritalStatusType",
                "contactDetails.childDetails.childGenderType",
                "professionalExperiences",
                "qualificationExperiences",
                "contactDocMaps",
                "reportingTo",
                "relationshipType",
                "communicationDetails",
                "companyLocation",
            ];
            if (contactRecord === constants_2.CONTACT_RECORD_TYPE_MAP.COMPANY_CONTACT_RECORD_TYPE) {
                contactRelations.push("companyContactMaps.company.companyAddresses.address.addressType");
            }
            else if (contactRecord === constants_2.CONTACT_RECORD_TYPE_MAP.INSURER_CONTACT_RECORD_TYPE) {
                contactRelations.push("insurerContacts.insurer.insurerAddresses.address.addressType", "insurerContacts.insurer.isLife", "insurerContacts.insurer.companyType", "insurerContacts.insurer.companyTag", "insurerContacts.insurer.status");
            }
            else if (contactRecord === constants_2.CONTACT_RECORD_TYPE_MAP.TPA_CONTACT_RECORD_TYPE) {
                contactRelations.push("tpaContacts.tpa.tpaAddresses.address.addressType", "tpaContacts.tpa.status");
            }
            else if (contactRecord === constants_2.CONTACT_RECORD_TYPE_MAP.BROKER_CONTACT_RECORD_TYPE) {
                contactRelations.push("brokerContacts.broker.brokerAddresses.address.addressType", "brokerContacts.broker.status", "brokerContacts.broker.companyType");
            }
            const contact = await this.contactRepository.findOne({
                where: { id },
                relations: contactRelations,
            });
            if (!contact) {
                throw new common_1.NotFoundException(`Contact with ID ${id} not found`);
            }
            const lookUpValues = await this.entityService.getLookupValues([
                contact.salutationLid,
                contact?.tagLid ?? 0,
                contact?.contactTypeLid ?? 0,
                contact.statusLid,
                contact.relationshipTypeLid,
                contact.contactRecordTypeLid,
            ]);
            const salutation = lookUpValues.find((item) => item.id === contact.salutationLid) ?? null;
            const tag = lookUpValues.find((item) => item.id === contact.tagLid) ?? null;
            const contactType = lookUpValues.find((item) => item.id === contact.contactTypeLid) ?? null;
            const status = lookUpValues.find((item) => item.id === contact.statusLid) ?? null;
            let contactRecordType = null;
            const contactRecordTypeData = await this.lookUpRepository.findOne({
                where: { id: contact.contactRecordTypeLid },
            });
            if (contactRecordTypeData) {
                contactRecordType = contactRecordTypeData;
            }
            else {
                contactRecordType = null;
            }
            const relationshipType = lookUpValues.find((item) => item.id === contact.relationshipTypeLid) ??
                null;
            const enrichedContact = {
                ...contact,
                salutation,
                tag,
                contactType,
                status,
                contactRecordType,
                relationshipType,
            };
            return this.transformContacts(enrichedContact);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.contactQueryFetchFailed));
        }
    }
    async getContactCompanyDataAddress(id) {
        try {
            const existingContactDetails = await this.getExistingContactDetails(id);
            const contactRecord = constants_2.CONTACT_RECORD_TYPE_MAP[existingContactDetails?.contactRecordType
                ?.lookUpKey];
            const contactRelations = ["status", "contactRecordType"];
            if (contactRecord === constants_2.CONTACT_RECORD_TYPE_MAP.COMPANY_CONTACT_RECORD_TYPE) {
                contactRelations.push("companyContactMaps.company.companyAddresses.address.addressType");
            }
            else if (contactRecord === constants_2.CONTACT_RECORD_TYPE_MAP.INSURER_CONTACT_RECORD_TYPE) {
                contactRelations.push("insurerContacts.insurer.insurerAddresses.address.addressType");
            }
            else if (contactRecord === constants_2.CONTACT_RECORD_TYPE_MAP.TPA_CONTACT_RECORD_TYPE) {
                contactRelations.push("tpaContacts.tpa.tpaAddresses.address.addressType");
            }
            else if (contactRecord === constants_2.CONTACT_RECORD_TYPE_MAP.BROKER_CONTACT_RECORD_TYPE) {
                contactRelations.push("brokerContacts.broker.brokerAddresses.address.addressType");
            }
            const contact = await this.contactRepository.findOne({
                where: { id },
                relations: contactRelations,
            });
            if (!contact) {
                throw new common_1.NotFoundException(`Contact with ID ${id} not found`);
            }
            return this.transformContacts(contact);
        }
        catch (error) {
            console.log("Error in getContactCompanyDataAddress:", error);
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.contactQueryFetchFailed));
        }
    }
    /** Updates the details of an existing contact. */
    async updateContact(id, updateContact) {
        const queryRunner = this.dataSource.createQueryRunner();
        await queryRunner.connect();
        await queryRunner.startTransaction();
        try {
            const contact = await this.contactRepository.preload({
                id: id,
                ...updateContact,
            });
            if (!contact) {
                throw new common_1.NotFoundException(`Contact with ID ${id} not found`);
            }
            const updatedContact = await queryRunner.manager.save(constants_1.DEFAULT_CONTACT_ENTITY_NAME, contact);
            await queryRunner.commitTransaction();
            return updatedContact;
        }
        catch (error) {
            await queryRunner.rollbackTransaction();
            throw error instanceof common_1.NotFoundException
                ? error
                : new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.contactQueryUpdationFailed));
        }
        finally {
            await queryRunner.release();
        }
    }
    /** Removes a contact from the database. */
    async removeContact(contact) {
        try {
            const contactData = await this.contactRepository.findOne({
                where: { id: contact.id },
                select: ["id", "statusLid"],
            });
            if (!contactData) {
                throw new common_1.NotFoundException(`Contact with ID ${contact.id} not found`);
            }
            const deleteQuery = {
                deletedAt: new Date(),
                ...(contactData.statusLid === constants_1.DEFAULT_CONTACT_STATUS_ACTIVE_KEY_ID && {
                    statusLid: constants_1.DEFAULT_CONTACT_STATUS_INACTIVE_KEY_ID,
                }),
            };
            await this.contactRepository.update(contact.id, deleteQuery);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(`Failed to delete contact`);
        }
    }
    /** Creates a new contact and address mapping in the ContactAddress Table */
    async createContactAddressMapping(contactAddressData) {
        try {
            const contactAddress = this.contactAddressRepository.create({
                contact: { id: contactAddressData.contactId },
                address: { id: contactAddressData.addressId },
            });
            return await this.contactAddressRepository.save(contactAddress);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.contactAddressMappingCreationFailed));
        }
    }
    /** Creates a new company and address mapping in the CompanyAddress Table */
    async createCompanyAddressMapping(companyAddressData) {
        try {
            const companyAddress = this.companyAddressRepository.create(companyAddressData);
            await this.companyAddressRepository.save(companyAddress);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.companyAddressMappingCreationFailed));
        }
    }
    /** Finds the address and contact data mapping in ContactAddress Table */
    async findContactAddressMap(contactId, addressId) {
        return this.contactAddressRepository.findOne({
            where: {
                contact: { id: contactId },
                address: { id: addressId },
            },
        });
    }
    /** Finds the address and company data mapping in CompanyAddress Table */
    async findCompanyAddressMap(companyId, addressId) {
        return this.companyAddressRepository.findOne({
            where: {
                company: { id: companyId },
                address: { id: addressId },
            },
        });
    }
    /** Updates the communication details associated with the contact */
    async updateCommunicationDetails(id, communicationDetailsData) {
        const existingDetails = await this.contactCommunicationDetailsRepository.findOne({
            where: { id },
        });
        if (!existingDetails) {
            throw new common_1.NotFoundException(`ContactCommunicationDetails with ID ${id} not found`);
        }
        const updateData = { ...communicationDetailsData };
        if (communicationDetailsData.contact) {
            updateData.contact = { id: communicationDetailsData.contact };
        }
        const mergedDetails = this.contactCommunicationDetailsRepository.merge(existingDetails, updateData);
        return this.contactCommunicationDetailsRepository.save(mergedDetails);
    }
    /** Create a new communication details associated with the contact */
    async createContactCommunicationDetails(communicationDetailsData) {
        try {
            const contactDetails = this.contactCommunicationDetailsRepository.create({
                contactId: communicationDetailsData.contact,
                communicationType: communicationDetailsData.communicationType,
                communicationDetails: communicationDetailsData.communicationDetails,
                isPrimary: communicationDetailsData.isPrimary ?? false,
                createdBy: communicationDetailsData.createdBy,
                updatedBy: communicationDetailsData.updatedBy,
            });
            return await this.contactCommunicationDetailsRepository.save(contactDetails);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.contactQueryCreationFailed));
        }
    }
    /** Transforms the contact by renaming `contactAddresses` to `address` and formatting the response. */
    async transformContacts(contactOrContacts) {
        const mapAddress = (contactAddress) => ({
            id: contactAddress.address?.id,
            addressTypeLid: contactAddress.address?.addressTypeLid,
            addressType: mapLookup(contactAddress.address?.addressType),
            address1: contactAddress.address?.address1,
            address2: contactAddress.address?.address2,
            area: contactAddress.address?.area,
            countryId: contactAddress.address?.countryId,
            stateId: contactAddress.address?.stateId,
            cityId: contactAddress.address?.cityId,
            pinCode: contactAddress.address?.pinCode,
            email: contactAddress.address?.email,
            phoneNumber: contactAddress.address?.phoneNumber,
            alternatePhoneNumber: contactAddress.address?.alternatePhoneNumber,
            supportNumber: contactAddress.address?.supportNumber,
        });
        const mapContactDetail = (detail) => ({
            id: detail?.id,
            gender: detail?.gender,
            dateOfBirth: detail?.dateOfBirth,
            favouriteFood: detail?.favouriteFood,
            favouriteRestaurant: detail?.favouriteRestaurant,
            personalHistory: detail?.personalHistory,
            majorAchievements: detail?.majorAchievements,
            maritalStatus: detail?.maritalStatus,
            dateOfWedding: detail?.dateOfWedding,
            spouseName: detail?.spouseName,
            spouseDateOfBirth: detail?.spouseDateOfBirth,
            spouseWorkingStatus: detail?.spouseWorkingStatus,
            workingCompany: detail?.workingCompany,
            childDetails: detail?.childDetails?.map(mapChildDetail),
            genderType: mapLookup(detail?.genderType),
            spouseWorkingStatusType: mapLookup(detail?.spouseWorkingStatusType),
            maritalStatusType: mapLookup(detail?.maritalStatusType),
        });
        const mapExperience = (exp) => ({
            id: exp.id,
            fromDate: exp.fromDate,
            toDate: exp.toDate,
            designation: exp.designation,
            department: exp.department,
            company: exp.company,
            details: exp.details,
        });
        const mapQualification = (qual) => ({
            id: qual.id,
            nameOfQualification: qual.nameOfQualification,
            yearOfQualification: qual.yearOfQualification,
            details: qual.details,
            universityName: qual.universityName,
        });
        const mapLookup = (lookup) => ({
            id: lookup?.id,
            lookUpValue: lookup?.lookUpValue,
        });
        const mapCity = (city) => ({
            id: city?.id,
            lookUpValue: city?.name,
        });
        const mapContactDocs = (doc) => ({
            id: doc?.id,
            documentId: doc?.documentId,
        });
        const mapChildDetail = (doc) => ({
            id: doc?.id,
            childName: doc?.childName,
            childDob: doc?.childDob,
            childGender: doc?.childGender,
            childGenderType: mapLookup(doc?.childGenderType),
            contactDetailsId: doc?.contactDetailsId,
        });
        const mapCommunicationDetails = (doc) => ({
            id: doc?.id,
            communicationType: doc?.communicationType,
            communicationDetails: doc?.communicationDetails,
            isPrimary: doc?.isPrimary,
        });
        const mapCompany = (company) => company
            ? {
                id: company.id,
                companyName: company.companyName,
                displayName: company.displayName,
                companyTypeLid: company.companyTypeLid,
                companyTagLid: company.companyTagLid,
                currencyId: company.currencyId,
                industrySegmentLid: company.industrySegmentLid,
                groupCompanyLid: company.groupCompanyLid,
                noOfEmployees: company.noOfEmployees,
                website: company.website,
                dateOfIncorporation: company.dateOfIncorporation,
                panCardNumber: company.panCardNumber,
                registrationNo: company.registrationNo,
                existingBrokerId: company.existingBrokerId,
                paidUpCapital: company.paidUpCapital,
                tanNumber: company.tanNumber,
                priorityLid: company.priorityLid,
                statusLid: company.statusLid,
                remarks: company.remarks,
                source: company.source,
                companyAddresses: company.companyAddresses,
            }
            : null;
        const mapInsurerCompany = (company) => company
            ? {
                id: company.id,
                insurerName: company.insurerName,
                displayName: company.displayName,
                companyTypeLid: company.companyTypeLid,
                website: company.website,
                isLifeLid: company.isLifeLid,
                companyTagLid: company.companyTagLid,
                remarks: company.remarks,
                insureCode: company.insureCode,
                statusLid: company.statusLid,
                isLife: mapLookup(company.isLife),
                companyType: mapLookup(company.companyType),
                companyTag: mapLookup(company.companyTag),
                status: mapLookup(company.status),
                companyAddresses: company.insurerAddresses,
            }
            : null;
        const mapTpaCompany = (company) => company
            ? {
                id: company.id,
                tpaName: company.tpaName,
                displayName: company.displayName,
                companyTypeLid: company.companyTypeLid,
                website: company.website,
                remarks: company.remarks,
                statusLid: company.statusLid,
                status: mapLookup(company.status),
                companyAddresses: company.tpaAddresses,
            }
            : null;
        const mapBrokerCompany = (company) => company
            ? {
                id: company?.id,
                brokerName: company?.brokerName,
                displayName: company.displayName,
                companyTypeLid: company.companyTypeLid,
                website: company.website,
                remarks: company.remarks,
                statusLid: company.statusLid,
                status: mapLookup(company.status),
                companyType: mapLookup(company.companyType),
                companyAddresses: company.brokerAddresses,
            }
            : null;
        const transform = (contact) => ({
            id: contact?.id,
            firstName: contact?.firstName,
            lastName: contact?.lastName,
            middleName: contact?.middleName,
            displayName: contact?.displayName,
            companyLocationId: contact?.companyLocationId,
            companyBranchId: contact?.companyBranchId,
            remarks: contact?.remarks,
            linkedInUrl: contact?.linkedInUrl,
            relationshipTypeLid: contact?.relationshipTypeLid,
            relationshipType: mapLookup(contact?.relationshipType),
            address: contact?.contactAddresses?.map(mapAddress),
            contactDetails: mapContactDetail(contact?.contactDetails),
            professionalExperiences: contact?.professionalExperiences?.map(mapExperience),
            qualificationExperiences: contact?.qualificationExperiences?.map(mapQualification),
            contactDocMaps: contact?.contactDocMaps?.map(mapContactDocs),
            communicationDetails: contact?.communicationDetails?.map(mapCommunicationDetails),
            salutation: contact.salutation,
            tag: contact.tag,
            contactType: contact.contactType,
            department: contact?.department ? contact?.department : null,
            designation: contact?.designation ? contact?.designation : null,
            status: contact.status,
            contactRecordType: contact.contactRecordType,
            company: constants_2.CONTACT_RECORD_TYPE_MAP[contact?.contactRecordType
                .lookUpKey] === constants_2.CONTACT_RECORD_TYPE_MAP.COMPANY_CONTACT_RECORD_TYPE
                ? mapCompany(contact?.companyContactMaps[0]?.company)
                : constants_2.CONTACT_RECORD_TYPE_MAP[contact?.contactRecordType
                    .lookUpKey] === constants_2.CONTACT_RECORD_TYPE_MAP.INSURER_CONTACT_RECORD_TYPE
                    ? mapInsurerCompany(contact?.insurerContacts[0]?.insurer)
                    : constants_2.CONTACT_RECORD_TYPE_MAP[contact?.contactRecordType
                        .lookUpKey] === constants_2.CONTACT_RECORD_TYPE_MAP.TPA_CONTACT_RECORD_TYPE
                        ? mapTpaCompany(contact?.tpaContacts[0]?.tpa)
                        : mapBrokerCompany(contact?.brokerContacts[0]?.broker),
            companyLocation: mapCity(contact?.companyLocation),
            companyId: constants_2.CONTACT_RECORD_TYPE_MAP[contact?.contactRecordType
                .lookUpKey] === constants_2.CONTACT_RECORD_TYPE_MAP.COMPANY_CONTACT_RECORD_TYPE
                ? contact?.companyContactMaps[0]?.company?.id
                : constants_2.CONTACT_RECORD_TYPE_MAP[contact?.contactRecordType
                    .lookUpKey] === constants_2.CONTACT_RECORD_TYPE_MAP.INSURER_CONTACT_RECORD_TYPE
                    ? contact?.insurerContacts[0]?.insurer?.id
                    : constants_2.CONTACT_RECORD_TYPE_MAP[contact?.contactRecordType
                        .lookUpKey] === constants_2.CONTACT_RECORD_TYPE_MAP.TPA_CONTACT_RECORD_TYPE
                        ? contact?.tpaContacts[0]?.tpa?.id
                        : contact?.brokerContacts[0]?.broker?.id,
            salesOpportunity: [],
            renewalOpportunity: [],
            policy: [],
            reportingTo: contact?.reportingTo
                ? {
                    id: contact?.reportingTo?.id,
                    firstName: contact?.reportingTo?.firstName,
                    lastName: contact?.reportingTo?.lastName,
                }
                : null,
        });
        return Array.isArray(contactOrContacts)
            ? contactOrContacts.map(transform)
            : transform(contactOrContacts);
    }
    /** Updates an existing qualification experience. */
    async updateQualificationExperience(id, qualificationExperienceData) {
        const existingQualification = await this.qualificationExperienceRepository.findOne({
            where: { id },
        });
        if (!existingQualification) {
            throw new common_1.NotFoundException(`QualificationExperience with ID ${id} not found`);
        }
        const partialData = { ...qualificationExperienceData };
        if (qualificationExperienceData.contact) {
            partialData.contact = { id: qualificationExperienceData.contact };
        }
        const mergedQualification = this.qualificationExperienceRepository.merge(existingQualification, partialData);
        return await this.qualificationExperienceRepository.save(mergedQualification);
    }
    /** Updates an existing professional experience. */
    async updateProfessionalExperience(id, professionalExperienceData) {
        const existingExperience = await this.professionalExperienceRepository.findOne({ where: { id } });
        if (!existingExperience) {
            throw new common_1.NotFoundException(`ProfessionalExperience with ID ${id} not found`);
        }
        const mergedExperience = this.professionalExperienceRepository.merge(existingExperience, professionalExperienceData);
        return await this.professionalExperienceRepository.save(mergedExperience);
    }
    /** Updates an existing contact detail. */
    async updateContactDetails(id, contactDetailsData) {
        const existingDetails = await this.contactDetailsRepository.findOne({
            where: { id },
        });
        if (!existingDetails) {
            throw new common_1.NotFoundException(`ContactDetails with ID ${id} not found`);
        }
        const mergedDetails = this.contactDetailsRepository.merge(existingDetails, contactDetailsData);
        return await this.contactDetailsRepository.save(mergedDetails);
    }
    /** Updates an existing contact document mapping details */
    async updateContactDocumentDetails(id, contactDocDetails) {
        const existingDetails = await this.contactDocumentMapRepository.findOne({
            where: { id },
        });
        if (!existingDetails) {
            throw new common_1.NotFoundException(`ContactDocMap with ID ${id} not found`);
        }
        const mergedDetails = this.contactDocumentMapRepository.merge(existingDetails, contactDocDetails);
        return await this.contactDocumentMapRepository.save(mergedDetails);
    }
    /** Gets the total number of unique companies based on contacts. */
    async getTotalCompanies(userQuery, searchString, searchArray) {
        try {
            const { contactRecordTypeLid, ...filters } = userQuery;
            const contactQueryData = this.contactRepository.createQueryBuilder(constants_1.DEFAULT_CONTACT_ENTITY_NAME.toLowerCase());
            let searchOn = [];
            const contactRecordTypeLookup = await this.lookUpRepository.findOne({
                where: { id: contactRecordTypeLid },
            });
            const recordType = constants_2.CONTACT_RECORD_TYPE_MAP[contactRecordTypeLookup.lookUpKey];
            if (recordType === constants_2.CONTACT_RECORD_TYPE_MAP.COMPANY_CONTACT_RECORD_TYPE) {
                contactQueryData
                    .leftJoin("contact.companyContactMaps", "ccm")
                    .leftJoin("ccm.company", "company")
                    .leftJoin("contact.communicationDetails", "cd")
                    .leftJoin("contact.status", "status")
                    .leftJoin("contact.tag", "tag")
                    .select("COUNT(DISTINCT company.id)", "count");
                searchOn = [
                    "first_name",
                    "middle_name",
                    "last_name",
                    "company.company_name",
                    "cd.communication_details",
                    "status.value",
                    "tag.value",
                ];
            }
            else if (recordType === constants_2.CONTACT_RECORD_TYPE_MAP.INSURER_CONTACT_RECORD_TYPE) {
                contactQueryData
                    .leftJoin("contact.insurerContacts", "ic")
                    .leftJoin("ic.insurer", "insurer")
                    .leftJoin("contact.communicationDetails", "cd")
                    .leftJoin("contact.status", "status")
                    .leftJoin("contact.tag", "tag")
                    .select("COUNT(DISTINCT insurer.id)", "count");
                searchOn = [
                    "first_name",
                    "middle_name",
                    "last_name",
                    "insurer.name",
                    "cd.communication_details",
                    "status.value",
                    "tag.value",
                ];
            }
            else if (recordType === constants_2.CONTACT_RECORD_TYPE_MAP.TPA_CONTACT_RECORD_TYPE) {
                contactQueryData
                    .leftJoin("contact.tpaContacts", "tc")
                    .leftJoin("tc.tpa", "tpa")
                    .leftJoin("contact.communicationDetails", "cd")
                    .leftJoin("contact.status", "status")
                    .leftJoin("contact.tag", "tag")
                    .select("COUNT(DISTINCT tc.id)", "count");
                searchOn = [
                    "first_name",
                    "middle_name",
                    "last_name",
                    "tpa.name",
                    "cd.communication_details",
                    "status.value",
                    "tag.value",
                ];
            }
            else if (recordType === constants_2.CONTACT_RECORD_TYPE_MAP.BROKER_CONTACT_RECORD_TYPE) {
                contactQueryData
                    .leftJoin("contact.brokerContacts", "bc")
                    .leftJoin("bc.broker", "broker")
                    .leftJoin("contact.communicationDetails", "cd")
                    .leftJoin("contact.status", "status")
                    .leftJoin("contact.tag", "tag")
                    .select("COUNT(DISTINCT broker.id)", "count");
                searchOn = [
                    "first_name",
                    "middle_name",
                    "last_name",
                    "broker.broker_name",
                    "cd.communication_details",
                    "status.value",
                    "tag.value",
                ];
            }
            else {
                throw new Error("Unsupported contactRecordTypeLid");
            }
            contactQueryData.where("contact.createdBy = :createdBy", {
                createdBy: filters.createdBy,
            });
            for (const search of searchArray || []) {
                const key = search.searchBy;
                const value = `%${search.searchValue}%`;
                if (key === "department") {
                    contactQueryData.andWhere("LOWER(contact.department) LIKE LOWER(:deptName)", {
                        deptName: value,
                    });
                }
                else if (key === "designation") {
                    contactQueryData.andWhere("LOWER(contact.designation) LIKE LOWER(:designationName)", {
                        designationName: value,
                    });
                }
                else if (key === "owner.firstName") {
                    contactQueryData.leftJoin("contact.owner", "owner");
                    contactQueryData.andWhere("LOWER(owner.firstName) LIKE LOWER(:ownerName)", {
                        ownerName: value,
                    });
                }
                else if (key === "companyContactMaps.company.companyName") {
                    contactQueryData.andWhere("LOWER(company.companyName) LIKE LOWER(:companyName)", {
                        companyName: value,
                    });
                }
                else if (key === "insurerContacts.insurer.insurerName") {
                    contactQueryData.andWhere("LOWER(insurer.insurerName) LIKE LOWER(:insurerName)", {
                        insurerName: value,
                    });
                }
                else if (key === "tpaContacts.tpa.tpaName") {
                    contactQueryData.andWhere("LOWER(tpa.tpaName) LIKE LOWER(:tpaName)", {
                        tpaName: value,
                    });
                }
                else if (key === "brokerContacts.broker.brokerName") {
                    contactQueryData.andWhere("LOWER(broker.brokerName) LIKE LOWER(:brokerName)", {
                        brokerName: value,
                    });
                }
                else if (key ===
                    "companyContactMaps.company.companyAddresses.address.cityId.name") {
                    contactQueryData.leftJoin("company.companyAddresses", "companyAddresses");
                    contactQueryData.leftJoin("companyAddresses.address", "address");
                    contactQueryData.leftJoin("address.cityId", "cityId");
                    contactQueryData.andWhere("LOWER(cityId.name) LIKE LOWER(:cityName)", {
                        cityName: value,
                    });
                }
                else if (key === "insurerContacts.insurer.insurerAddresses.address.cityId.name") {
                    contactQueryData.leftJoin("insurer.insurerAddresses", "insurerAddresses");
                    contactQueryData.leftJoin("insurerAddresses.address", "address");
                    contactQueryData.leftJoin("address.cityId", "cityId");
                    contactQueryData.andWhere("LOWER(cityId.name) LIKE LOWER(:cityName)", {
                        cityName: value,
                    });
                }
                else if (key === "tpaContacts.tpa.tpaAddresses.address.cityId.name") {
                    contactQueryData.leftJoin("tpa.tpaAddresses", "tpaAddresses");
                    contactQueryData.leftJoin("tpaAddresses.address", "address");
                    contactQueryData.leftJoin("address.cityId", "cityId");
                    contactQueryData.andWhere("LOWER(cityId.name) LIKE LOWER(:cityName)", {
                        cityName: value,
                    });
                }
                else if (key === "brokerContacts.broker.brokerAddresses.address.cityId.name") {
                    contactQueryData.leftJoin("broker.brokerAddresses", "brokerAddresses");
                    contactQueryData.leftJoin("brokerAddresses.address", "address");
                    contactQueryData.leftJoin("address.cityId", "cityId");
                    contactQueryData.andWhere("LOWER(cityId.name) LIKE LOWER(:cityName)", {
                        cityName: value,
                    });
                }
            }
            if (searchString?.trim() &&
                Array.isArray(searchOn) &&
                searchOn.length > 0) {
                const searchTerms = searchString.trim().split(/\s+/);
                const searchConditions = [];
                // Check if all contact name fields are present
                const hasFullNameFields = searchOn.includes("first_name") &&
                    searchOn.includes("middle_name") &&
                    searchOn.includes("last_name");
                // Enhanced full name search logic
                if (hasFullNameFields) {
                    if (searchTerms.length === 2) {
                        const [first, second] = searchTerms;
                        contactQueryData.setParameter("firstName_twoWords", `%${first}%`);
                        contactQueryData.setParameter("middleOrLastName_twoWords", `%${second}%`);
                        searchConditions.push(`(
              contact.first_name ILIKE :firstName_twoWords AND (
              contact.middle_name ILIKE :middleOrLastName_twoWords OR
              contact.last_name ILIKE :middleOrLastName_twoWords
              )
            )`);
                        // Optional: reverse order
                        contactQueryData.setParameter("lastName_twoWords_alt", `%${first}%`);
                        contactQueryData.setParameter("firstName_twoWords_alt", `%${second}%`);
                        searchConditions.push(`(
              contact.last_name ILIKE :lastName_twoWords_alt AND 
              contact.first_name ILIKE :firstName_twoWords_alt
            )`);
                    }
                    else if (searchTerms.length === 3) {
                        const [first, middle, last] = searchTerms;
                        contactQueryData.setParameter("firstName_threeWords", `%${first}%`);
                        contactQueryData.setParameter("middleName_threeWords", `%${middle}%`);
                        contactQueryData.setParameter("lastName_threeWords", `%${last}%`);
                        searchConditions.push(`(
              contact.first_name ILIKE :firstName_threeWords AND 
              contact.middle_name ILIKE :middleName_threeWords AND 
              contact.last_name ILIKE :lastName_threeWords
            )`);
                    }
                }
                // Field-based ILIKE conditions
                const genericSearchConditions = searchOn.map((field, index) => {
                    let alias, column;
                    if (field.includes(".")) {
                        const parts = field.split(".");
                        column = parts.pop();
                        alias = parts.join("_");
                    }
                    else {
                        alias = "contact";
                        column = field;
                    }
                    const paramKey = `searchParam_${index}`;
                    contactQueryData.setParameter(paramKey, `%${searchString}%`);
                    return `${alias}.${column} ILIKE :${paramKey}`;
                });
                const allConditions = [...searchConditions, ...genericSearchConditions];
                if (allConditions.length > 0) {
                    contactQueryData.andWhere(`(${allConditions.join(" OR ")})`);
                }
            }
            const result = await contactQueryData.getRawOne();
            const uniqueParentCount = parseInt(result.count, 10);
            return uniqueParentCount;
        }
        catch (error) {
            return constants_1.DEFAULT_TOTAL_KPI_COUNT;
        }
    }
    /** Gets the total number of contacts based on filters. */
    async getTotalContacts(whereCondition, contactSearchObject, searchArray, searchBy) {
        try {
            const contactRecordTypeLookup = await this.lookUpRepository.findOne({
                where: { id: whereCondition.contactRecordTypeLid },
            });
            const recordType = constants_2.CONTACT_RECORD_TYPE_MAP[contactRecordTypeLookup.lookUpKey];
            const relations = await this.getContactRelations(recordType);
            const { count } = await this.entityService.fetchEntityList(constants_1.DEFAULT_CONTACT_ENTITY_NAME, constants_1.DEFAULT_PAGE, constants_1.DEFAULT_PAGE, undefined, relations, whereCondition, undefined, searchArray, undefined, searchBy, contactSearchObject);
            return count;
        }
        catch (error) {
            return constants_1.DEFAULT_TOTAL_KPI_COUNT;
        }
    }
    /** Creates an document details associated with contact*/
    async createContactDocumentMapping(docObject) {
        try {
            const contactDocMap = this.contactDocumentMapRepository.create(docObject);
            const savedContactDocMap = await this.contactDocumentMapRepository.save(contactDocMap);
            return savedContactDocMap;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.contactDocumentMappingCreationFailed));
        }
    }
    /** Creates an contact company details mapping*/
    async createCompanyContactMapping(docObject) {
        try {
            const contactCompanyMap = this.companyContactMapRepository.create(docObject);
            return await this.companyContactMapRepository.save(contactCompanyMap);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.companyContactMappingCreationFailed));
        }
    }
    /** Remove an contact company details mapping*/
    async delinkCompanyContactMapping(docObject) {
        try {
            await this.companyContactMapRepository.delete(docObject);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.companyContactMappingDeletionFailed));
        }
    }
    /** Generic method to check for duplicate communication details */
    async getCommunicationDetailsCheck(useSearchQuery, errorMessage) {
        try {
            const communicationDetails = await this.contactCommunicationDetailsRepository.find({
                where: useSearchQuery,
                relations: ["contact"],
            });
            return communicationDetails;
        }
        catch (error) {
            throw new common_1.BadRequestException(errorMessage);
        }
    }
    /** Public method to check duplicate phone numbers */
    async getCommunicationPhoneCheck(useSearchQuery) {
        try {
            delete useSearchQuery.contactName;
            let communicationDetails = await this.getCommunicationDetailsCheck(useSearchQuery, messages_1.errorMessages.communicationPhoneError);
            //If the given phone number is already active for a contact in the company, return an error;
            // otherwise, proceed to create the contact with the provided number.
            if (communicationDetails.length) {
                const status = await this.lookUpRepository.findOne({
                    where: { lookUpKey: constants_1.DEFAULT_CONTACT_STATUS_ACTIVE_KEY },
                });
                if (status?.id) {
                    communicationDetails = communicationDetails.filter((communication) => communication?.contact?.statusLid === status?.id);
                }
            }
            return communicationDetails;
        }
        catch (error) {
            throw new common_1.BadRequestException(messages_1.errorMessages.communicationPhoneError);
        }
    }
    /** Public method to check duplicate email addresses */
    async getCommunicationEmailCheck(useSearchQuery) {
        return this.getCommunicationDetailsCheck(useSearchQuery, messages_1.errorMessages.communicationEmailError);
    }
    async fetchConatctById(id) {
        const contact = await this.contactRepository.findOne({
            where: { id },
        });
        return contact?.id ?? null;
    }
    async getEntityTableMapIds(entity, select, whereCondition) {
        try {
            const data = await this.entityService.getEntityMapByIds(entity, select, whereCondition);
            return data;
        }
        catch (error) {
            return [];
        }
    }
    async deleteEntityTableMapIds(entity, deleteIds, select, deletionType) {
        try {
            await this.entityService.deleteEntityMapByIds(entity, deleteIds, select, deletionType);
        }
        catch (error) {
            throw new common_1.BadRequestException(error);
        }
    }
};
exports.ContactRepository = ContactRepository;
exports.ContactRepository = ContactRepository = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(contact_entity_1.Contact)),
    tslib_1.__param(1, (0, typeorm_1.InjectRepository)(contact_communication_details_entity_1.ContactCommunicationDetails)),
    tslib_1.__param(2, (0, typeorm_1.InjectRepository)(contact_details_entity_1.ContactDetails)),
    tslib_1.__param(3, (0, typeorm_1.InjectRepository)(child_details_entity_1.ChildDetails)),
    tslib_1.__param(4, (0, typeorm_1.InjectRepository)(professional_experience_entity_1.ProfessionalExperience)),
    tslib_1.__param(5, (0, typeorm_1.InjectRepository)(qualification_experience_entity_1.QualificationExperience)),
    tslib_1.__param(6, (0, typeorm_1.InjectRepository)(contact_address_entity_1.ContactAddress)),
    tslib_1.__param(7, (0, typeorm_1.InjectRepository)(company_address_entity_1.CompanyAddress)),
    tslib_1.__param(8, (0, typeorm_1.InjectRepository)(contact_document_map_entity_1.ContactDocMap)),
    tslib_1.__param(9, (0, typeorm_1.InjectRepository)(company_contact_entity_1.CompanyContactMap)),
    tslib_1.__param(10, (0, typeorm_1.InjectRepository)(insurer_entity_1.Insurer)),
    tslib_1.__param(11, (0, typeorm_1.InjectRepository)(tpa_entity_1.Tpa)),
    tslib_1.__param(12, (0, typeorm_1.InjectRepository)(look_up_entity_1.LookUp)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _b : Object, typeof (_c = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _c : Object, typeof (_d = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _d : Object, typeof (_e = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _e : Object, typeof (_f = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _f : Object, typeof (_g = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _g : Object, typeof (_h = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _h : Object, typeof (_j = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _j : Object, typeof (_k = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _k : Object, typeof (_l = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _l : Object, typeof (_m = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _m : Object, typeof (_o = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _o : Object, typeof (_p = typeof typeorm_2.DataSource !== "undefined" && typeorm_2.DataSource) === "function" ? _p : Object, typeof (_q = typeof entity_service_utils_1.EntityService !== "undefined" && entity_service_utils_1.EntityService) === "function" ? _q : Object, typeof (_r = typeof scope_utils_1.ScopeService !== "undefined" && scope_utils_1.ScopeService) === "function" ? _r : Object])
], ContactRepository);
